<template>
    <v-container v-if="evento_id" >
        <CuponDialog :evento_id="evento_id" @saveCupon="$event => { refrescarCupones() }" />
        <CuponesTabla :evento_id="evento_id" ref="cuponesTabla" />
    </v-container>
</template>
<script>

import CuponDialog from './components/CuponDialog.vue';
import CuponesTabla from './components/CuponesTabla.vue';

export default {
    data() {
        return { 
            evento_id: null
        }
    },
    mounted() {
        this.evento_id = this.$route.params.id;
    },
    methods: {
        refrescarCupones() {
            this.$refs.cuponesTabla.loadData();
        },
    },
    components: {
        CuponDialog,
        CuponesTabla
    }
}
</script>